export default {
    data() {
        return {
            activeTab: null,
        }
    },
    methods: {
        setActiveTab: function(value){
            this.activeTab = value;
        },
    }
}
